export const httpStatusCodes = {
  200: 200,
  400: 400,
  401: 401,
  403: 403,
  404: 404,
  409: 409,
};
